// extracted by mini-css-extract-plugin
export default {"title":"_kyc_title__9XP7l","chip":"_kyc_chip__ncxhr","footer":"_kyc_footer__NA+t5","exportXLS":"_kyc_exportXLS__poBHy","downloadButton":"_kyc_downloadButton__eDkzw"};